<h2 mat-dialog-title>Add Qualifications</h2>

<mat-dialog-content>
  <div class="dialog-content-container">

      <app-select-input [label]="'What qualification do ' + applicantText.you.toLowerCase() + ' have?'" [control]="qualificationForm.controls.type"
        [lookupItems]="qualificationLevels" shortLabel="Qualification" placeholder="Select a Qualification">
      </app-select-input>

      <app-text-input [label]="'Name of the course ' + applicantText.you.toLowerCase() + ' studied?'" [control]="qualificationForm.controls.course" shortLabel="Course">
      </app-text-input>

      <app-text-input [label]="'Name of the institution where ' + applicantText.you.toLowerCase() + ' studied?'" [control]="qualificationForm.controls.institution" shortLabel="Institution">
      </app-text-input>
  
      <app-select-input [label]="'In which country did ' + applicantText.you.toLowerCase() + ' study?'" [control]="qualificationForm.controls.country"
        [lookupItems]="countries" shortLabel="Country" placeholder="Select a Country">
      </app-select-input>


    @if (qualificationForm.controls.country.value?.value === 'Australia') {

      <app-text-input [label]="'Postcode where ' + applicantText.you.toLowerCase() + ' studied?'" [control]="qualificationForm.controls.postcode" shortLabel="Postcode">
      </app-text-input>

    }

    <app-date-input [label]="'When did ' + applicantText.you.toLowerCase() + ' start studying?'" [control]="qualificationForm.controls.start" shortLabel="Start Date">
    </app-date-input>

    <app-date-input [label]="'When did ' + applicantText.you.toLowerCase() + ' stop studying? (leave blank if ' + applicantText.you.toLowerCase() + ' are still studying)'" [control]="qualificationForm.controls.end" shortLabel="End Date">
    </app-date-input>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="close()">OK</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>